import React, { useState, useEffect } from "react";
import Help_CTA from "../Home/Help_CTA";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";

import { ThreeDots } from "react-loader-spinner";

import { useTranslation } from "react-i18next";

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const BlogRD = () => {
  useDocumentTitle("Invu POS | Blog Resources");

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTypeContent, setSelectedTypeContent] = useState("All");
  const [selectedCountry, setSelectedCountry] = useState("All");
  const [filteredData, setFilteredData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [showResults, setShowResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleFilterButtonClick = () => {
    setIsLoading(true);
    const resultsSection = document.getElementById("results-section");
    resultsSection.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Simula una carga de 2 segundos
  };

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > 500) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleScrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const data = [
    {
        id: 1,
        name: "Descubre las nuevas Novedades de Invu POS",
        description:
          "¡Invu POS 3 sigue evolucionando! En esta nueva versión incorporamos integraciones con ADYEN y BOLD, mejoras clave en la apertura de caja, facturación electrónica y reportes, incluyendo el nuevo Reporte de Cierre del Día y el reporte de tasa de cambio. Ahora puedes eliminar clientes de una orden, confirmar número de invitados desde el iPad, y aprovechar herramientas como el importador masivo de imágenes y mejoras en administración multi-sucursal. También optimizamos la visualización de productos en negocios retail, la edición de descripciones y la lógica de ítems bloqueados. Todo pensado para que tu operación sea más ágil, precisa y conectada. ¡Actualízate y lleva tu punto de venta al siguiente nivel!",
        date: "May 12, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/descubre-las-nuevas-novedades-de-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Novedades-invu-pos.png",
        imageAlt: "",
        category: "Press release",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 2,
        name: "Checklist para saber si tu restaurante necesita cambiar su sistema POS hoy mismo",
        description:
          "En República Dominicana, la industria gastronómica ha crecido y evolucionado de manera acelerada en los últimos años. Esto ha obligado a los dueños de restaurantes a modernizar sus operaciones para mantenerse competitivos. Uno de los cambios más estratégicos —y a menudo ignorado— es la actualización del sistema POS (Point of Sale).",
        date: "May 12, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/checklist-para-saber-si-tu-restaurante-necesita-cambiar-su-sistema-pos-hoy-mismo",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/checklist-para-saber-si-tu-restaurante-necesita-cambiar-su-sistema-pos-hoy-mismo.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 3,
        name: "¿Vale la pena invertir en un sistema KDS? Comparativa con comandas tradicionales",
        description:
          "En el competitivo mundo de la gastronomía en República Dominicana, cada segundo cuenta. La velocidad del servicio, la precisión en la cocina y la eficiencia operativa son claves para que un restaurante se mantenga rentable y con buena reputación. En este contexto, surge una pregunta fundamental para muchos dueños y gerentes: ¿Vale la pena invertir en un sistema KDS (Kitchen Display System) o sigo con las comandas tradicionales en papel?",
        date: "May 26, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/vale-la-pena-invertir-en-un-sistema-kds-comparativa-con-comandas-tradicionales",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/vale-la-pena-invertir-en-un-sistema-kds-comparativa-con-comandas-tradicionales.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 4,
        name: "¿Está tu restaurante o tienda lista para 2025? Todo lo que debes saber sobre la facturación electrónica en República Dominicana",
        description:
          "En 2025, la facturación electrónica en República Dominicana será una obligación para todos los comercios, incluyendo restaurantes, tiendas, supermercados, panaderías y negocios retail. La Dirección General de Impuestos Internos (DGII) ya activó el calendario oficial para la adopción obligatoria del sistema de comprobantes fiscales electrónicos (e- CF).",
        date: "May 30, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/esta-tu-restaurante-o-tienda-lista-para-2025-todo-lo-que-debes-saber-sobre-la-facturacion-electronica-en-republica-dominicana",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/esta-tu-restaurante-o-tienda-lista-para-2025-todo-lo-que-debes-saber-sobre-la-facturacion-electronica-en-republica-dominicana.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 5,
        name: "Mejor Software POS para Restaurantes en República Dominicana",
        description:
          "En la industria gastronómica de República Dominicana, donde la competencia es cada vez mayor y los clientes exigen experiencias más rápidas y eficientes, contar con un sistema POS moderno, ágil y completo es clave para mantenerse a la vanguardia. En este artículo te contamos cuáles son las características que debe tener el mejor software POS para restaurantes en República Dominicana en 2025 y por qué Invu POS es la solución más completa del mercado, con facturación electrónica integrada.",
        date: "June 04, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/mejor-software-pos-para-restaurantes-en-republica-dominicana",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/mejor-software-pos-para-restaurantes-en-republica-dominicana.jpeg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 6,
        name: "¿Eres dueño o gerente de hotel? Esta integración entre Invu POS y Cloudbeds puede transformar tu operación",
        description:
          "Administrar un hotel es mucho más que ofrecer habitaciones cómodas. Es coordinar múltiples áreas operativas, asegurar una experiencia impecable para los huéspedes y, al mismo tiempo, mantener la rentabilidad del negocio. Y si en tu día a día trabajas con sistemas aislados —uno para las reservas, otro para el restaurante, otro para la facturación—, sabes lo complejo que puede ser mantener todo en orden.",
        date: "July 24, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/eres-dueño-o-gerente-de-hotel-esta-integracion-entre-invupos-y-cloudbeds-puede-transformar-tu-operacion",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/eres-due%C3%B1o-o-gerente-de-hotel-esta-integracion-entre-invupos-y-cloudbeds-puede-transformar-tu-operacion_uw17s3.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 7,
        name: "¿Delivery, takeout o en mesa? Invu POS lo centraliza todo en un solo lugar",
        description:
          "En el competitivo mundo gastronómico de República Dominicana, no basta con tener buena comida. Hoy los negocios que sobreviven —y sobre todo, los que crecen— son los que logran una operación sólida, rápida y flexible. ¿Y qué implica eso? Saber atender a tus clientes donde sea que estén: en el local, en su carro o en su casa.",
        date: "August 5, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/delivery-takeout-o-en-mesa-invu-pos-lo-centraliza-todo-en-un-solo-lugar",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Delivery-takeout-o-en-mesa.webp",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 8,
        name: "Hoteles inteligentes en República Dominicana: cómo un POS transforma la experiencia del huésped",
        description:
          "El turismo es el corazón de la economía dominicana y los hoteles son el epicentro de esa experiencia. Hoy, la clave no está solo en ofrecer una buena habitación, sino en brindar un servicio ágil, conectado y memorable en cada interacción: desde el check-in hasta el último café en el lobby.",
        date: "September 8, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/hoteles-inteligentes-en-republica-dominicana-como-un-pos-transforma-la-experiencia-del-huesped",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-juliana-romero-59970727-11482072_cm1imm.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 9,
        name: "5 formas en que la facturación digital con Invu POS mantiene tu negocio en orden",
        description:
          "En América Latina, los negocios se enfrentan a una realidad común: llevar el control de las ventas, el inventario y la facturación al mismo tiempo. Desde un pequeño café en Ciudad de México, hasta una cadena de restaurantes en Bogotá o un supermercado en Santo Domingo, todos comparten un reto: mantener el orden administrativo y cumplir con las regulaciones fiscales sin perder productividad.",
        date: "September 15, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cinco-formas-en-que-la-facturacion-digital-con-invu-pos-mantiene-tu-negocio-en-orden",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/mantiene-tu-negocio-en-orden.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 10,
        name: "Cómo transformar tu restaurante en un ecommerce rentable con Invu POS",
        description:
          "El mundo de la gastronomía ha cambiado. Ya no se trata solo de tener un buen menú o una excelente atención al cliente, sino de estar presente donde tus clientes están: en línea. Hoy, los restaurantes que combinan su operación física con un ecommerce eficiente no solo venden más, sino que también crean experiencias más completas, modernas y convenientes.",
        date: "October 6, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-transformar-tu-restaurante-en-un-ecommerce-rentable-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-olly-831012_yn3hvg.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 11,
        name: "10 formas en que un buen sistema POS transforma la eficiencia de tu restaurante",
        description:
          "Si hay algo que todos los dueños de restaurantes sabemos, es que un servicio rápido, preciso y amable puede marcar la diferencia entre un cliente que vuelve… y uno que no. Pero lo que a veces no se ve tan claro es cuánto influye la tecnología en ese resultado. Un equipo puede ser excelente, pero si no tiene las herramientas correctas, se desgasta, se frustra y pierde tiempo en tareas que podrían automatizarse.",
        date: "October 13, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/diez-formas-en-que-un-buen-sistema-pos-transforma-la-eficiencia-de-tu-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-lexi-lauwers-1431940-33867784.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 12,
        name: "El caos de fin de año en los restaurantes: cómo mantener el control con Invu POS",
        description:
          "Noviembre y diciembre son meses intensos para los restaurantes. Las reservas aumentan, los pedidos se multiplican y el flujo de clientes se dispara. Todo esto es una gran oportunidad de ventas, pero también puede convertirse en una pesadilla para quienes no tienen el control total de su operación. En medio de ese caos, los errores se vuelven más frecuentes: inventarios que no cuadran, tiempos de espera más largos, pedidos que se pierden, facturación atrasada y personal que simplemente no da abasto.",
        date: "November 11, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-caos-de-fin-de-ano-en-los-restaurantes-como-mantener-el-control-con-invu-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-picjumbo-com-55570-196648.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 13,
        name: "El caos en la cocina no es una opción: por qué un buen KDS puede cambiar tu cierre de año",
        description:
          "Diciembre no perdona. Las mesas llenas, los pedidos en fila, el personal corriendo entre la barra y la cocina, los tickets amontonados sobre la plancha. Es la temporada más intensa del año para cualquier restaurante, y también la que más pone a prueba la organización, la eficiencia y la tecnología detrás de cada operación.",
        date: "November 13, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-caos-en-la-cocina-no-es-una-opcion-por-que-un-buen-kds-puede-cambiar-tu-cierre-de-ano",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-adrien-olichon-1257089-2537605.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 14,
        name: "Cómo el Programa de Lealtad de Invu POS Impulsa tus Ventas en Navidad",
        description:
          "La temporada navideña es, sin duda, el momento más competitivo y emocionante del año para los comercios. Más clientes, más compras impulsivas, más promociones… pero también más opciones para elegir. En este ambiente tan movido, diferenciarte no solo depende de tener buenos productos o un excelente servicio. Hoy, la verdadera clave está en crear experiencias memorables que hagan que las personas vuelvan una y otra vez.",
        date: "November 17, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-el-programa-de-lealtad-de-invu-pos-impulsa-tus-ventas-en-navidad",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nicole-michalou-5764899.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 143,
        name: "Regalos que generan ingresos: cómo vender giftcards digitales con Invu POS esta Navidad",
        description:
          "La temporada navideña no solo es el momento más fuerte del año para las ventas: también es la oportunidad perfecta para que los comercios aumenten su alcance, conecten con nuevos clientes y generen ingresos incluso antes de que entren por la puerta. Y entre todas las estrategias posibles, hay una que destaca por ser simple, efectiva y altamente rentable: las giftcards digitales.",
        date: "December 03, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/regalos-que-generan-ingresos-como-vender-giftcards-digitales-con-invu-pos-esta-navidad",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-matteo-sassola-2156165555-35004242.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 144,
        name: "Cierre de Año, Ventas al Máximo: Cómo un POS Inteligente Impulsa tu Temporada de Diciembre",
        description:
          "Diciembre es ese mes donde todo se acelera: más clientes, más pedidos, más movimientos, más oportunidades… y también más retos. Para un restaurante, cafetería o comercio retail, diciembre puede ser el mes más rentable del año… o el más caótico, si no se cuenta con las herramientas adecuadas.",
        date: "December 04, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cierre-de-ano-ventas-al-maximo-como-un-pos-inteligente-impulsa-tu-temporada-de-diciembre",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-chanwalrus-941861.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 145,
        name: "Cómo preparar tu delivery para la temporada más movida del año",
        description:
          "En Navidad, los restaurantes enfrentan uno de los momentos más intensos del año: los pedidos aumentan, las expectativas del cliente suben y la operación necesita ser más eficiente que nunca. Aunque esta temporada representa una gran oportunidad para aumentar ventas, también puede volverse caótica si el negocio no está preparado.",
        date: "December 09, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-preparar-tu-delivery-para-la-temporada-mas-movida-del-ano",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-cottonbro-4114066.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 146,
        name: "Control de mesas y KDS: cuando diciembre pone a prueba tu restaurante",
        description:
          "En Navidad, los restaurantes enfrentan uno de los momentos más intensos del año: los pedidos aumentan, las expectativas del cliente suben y la operación necesita ser más eficiente que nunca. Aunque esta temporada representa una gran oportunidad para aumentar ventas, también puede volverse caótica si el negocio no está preparado.",
        date: "December 17, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/control-de-mesas-y-kds-cuando-diciembre-pone-a-prueba-tu-restaurante",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-anhelina-vasylyk-734724285-35001452.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 147,
        name: "Cuentas separadas, mesas felices: el secreto para sobrevivir a la temporada navideña",
        description:
          "La temporada navideña tiene algo especial. Las mesas se llenan, los brindis se multiplican y los restaurantes se convierten en el punto de encuentro de amigos, familias y compañeros de trabajo. Pero también es la época donde la operación se pone a prueba. Grupos grandes, pedidos variados y, al final de la noche, la gran pregunta: ¿cómo dividimos la cuenta?",
        date: "December 23, 2025",
        views: "2.3k",
        comments: "27",
        href: "/blog/cuentas-separadas-mesas-felices-el-secreto-para-sobrevivir-a-la-temporada-navidena",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nicole-michalou-5775048.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 148,
        name: "Enero: el mes perfecto para ordenar tu negocio y vender mejor con un POS moderno",
        description:
          "Enero marca el verdadero inicio del año para los negocios en México, Colombia y Panamá. Después de un diciembre intenso, llega el momento clave para analizar resultados, ordenar procesos y tomar decisiones que impactarán las ventas durante todo el año. Aquí es donde un sistema POS moderno deja de ser un gasto y se convierte en una herramienta estratégica.",
        date: "January 6, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/enero-el-mes-perfecto-para-ordenar-tu-negocio-y-vender-mejor-con-un-pos-moderno",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-chevanon-323503.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 149,
        name: "Tendencias tecnológicas para restaurantes y comercios en Latinoamérica en 2026",
        description:
          "Por qué Invu POS es el mejor sistema POS para crecer en la región El sector de restaurantes y comercios en Latinoamérica está atravesando una transformación acelerada. Los hábitos de consumo evolucionaron, los clientes son más digitales y la tecnología dejó de ser un lujo para convertirse en una herramienta clave de competitividad.",
        date: "January 12, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/tendencias-tecnologicas-restaurantes-comercios-latinoamerica-2026",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-nick-gorniok-495871763-35550991.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 150,
        name: "El futuro de los restaurantes y comercios en República Dominicana",
        description:
          "La tecnología POS que está transformando la forma de vender en 2026 El sector de restaurantes y comercios en República Dominicana está viviendo una etapa de fuerte crecimiento y modernización. El aumento del consumo digital, la expansión de los pagos electrónicos y la necesidad de mayor control operativo han llevado a los negocios dominicanos a buscar sistemas POS modernos, confiables y adaptados al mercado local.",
        date: "January 16, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/el-futuro-de-los-restaurantes-y-comercios-en-republica-dominicana",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/rd1.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 151,
        name: "Cómo reducir pérdidas y aumentar ganancias en tu restaurante en Santo Domingo con un sistema POS", 
        description:
          "En República Dominicana, el sector gastronómico vive uno de sus momentos más competitivos. Cada día abren nuevos conceptos en Santo Domingo, Santiago y Punta Cana. Pero mientras más competencia existe, más importante se vuelve tener control total del negocio. Si tienes un restaurante y sientes que el dinero “se va” sin saber exactamente cómo, este artículo es para ti.",
        date: "March 10, 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-reducir-perdidas-y-aumentar-ganancias-en-tu-restaurante-en-santo-domingo-con-un-sistema-pos",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-karola-g-5239818.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 152,
        name: "Cómo aumentar la frecuencia de clientes en tu restaurante sin invertir más en publicidad: el poder del Punch Card digital", 
        description:
          "Estrategias de fidelización que realmente generan ventas recurrentes En la industria gastronómica y retail, uno de los mayores errores es medir el crecimiento únicamente por la cantidad de nuevos clientes. La realidad es otra: los negocios más rentables no son los que más clientes atraen, sino los que logran que sus clientes regresen constantemente.",
        date: "March 19 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-aumentar-frecuencia-clientes-restaurante-sin-invertir-publicidad-punch-card-digital",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/73796c3b-9f88-40a9-a31c-49e9d32d83c3.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 153,
        name: "Cómo aumentar tus ventas en República Dominicana con un sistema POS inteligente en 2026", 
        description:
          "En República Dominicana, el comercio está viviendo una transformación silenciosa, pero profunda. Los negocios que antes funcionaban únicamente con experiencia, intuición y procesos manuales, hoy se enfrentan a un entorno donde la tecnología, la velocidad y los datos marcan la diferencia entre crecer o quedarse atrás.",
        date: "March 20 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-aumentar-tus-ventas-en-republica-dominicana-con-un-sistema-pos-inteligente-en-2026",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/pexels-cristian-rojas-7772190.jpg",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 154,
        name: "Cómo integrar delivery, cocina y caja en un solo sistema POS en República Dominicana", 
        description:
          "La industria gastronómica en República Dominicana ha cambiado radicalmente durante los últimos años. Los restaurantes ya no solo deben enfocarse en ofrecer buena comida y una excelente atención al cliente; ahora también necesitan operar de manera rápida, eficiente y totalmente conectada. El crecimiento del delivery, las órdenes online y la digitalización de los negocios ha obligado a muchos comercios a modernizar sus operaciones mediante un sistema POS para restaurantes que permita integrar delivery, cocina, caja e inventario en un solo lugar.",
        date: "May 07 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-integrar-delivery-cocina-y-caja-en-un-solo-sistema-pos-en-republica-dominicana",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/cb27b5c7-0eb3-416c-8b35-da4a1aa4c28d.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 155,
        name: "Cómo tener el control de tu restaurante aunque no estés en el local ", 
        description:
          "Ser dueño de un restaurante significa tomar decisiones todos los días. Ventas, inventario, empleados, proveedores, pedidos, gastos y clientes requieren atención constante. Pero, ¿qué pasa cuando no puedes estar físicamente en el restaurante? Para un propietario, administrador o gerente de un restaurante en República Dominicana, contar con información actualizada del negocio puede marcar una gran diferencia.",
        date: "October 01 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/como-tener-el-control-de-tu-restaurante-aunque-no-estes-en-el-local",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/9cfc9d60-5c42-452d-8d12-2204ef1d039e.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },
      {
        id: 156,
        name: "Sistema POS en República Dominicana: por qué tu negocio necesita una plataforma todo integrado", 
        description:
          "Descubre cómo un sistema POS integral puede ayudarte a gestionar ventas, inventario, facturación, pedidos y clientes desde una sola plataforma en República Dominicana.",
          date: "October 27 2026",
        views: "2.3k",
        comments: "27",
        href: "/blog/sistema-pos-republica-dominicana",
        imageSrc:
          "https://img.invupos.com/webinvu/Blog%20invu/Barista%20usando%20POS%20en%20cafeter%C3%ADa%20moderna.png",
        imageAlt: "",
        category: "Management",
        typecontent: "Articles",
        country: "Republica Dominicana", 
      },  
  ];

  const sortedData = data.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
  const sortedFilteredData = filteredData
  ? filteredData.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
  : null;

  const filterItems = () => {
    let filteredData;
  
    if (
      selectedCategory === "All" &&
      selectedTypeContent === "All" &&
      selectedCountry === "All"
    ) {
      // If all filters are "All", show all blogs
      filteredData = data;
    } else {
      // Apply filtering logic based on selected values
      filteredData = data.filter((item) => {
        const categoryCondition = selectedCategory === "All" || item.category === selectedCategory;
        const typeContentCondition = selectedTypeContent === "All" || item.typecontent === selectedTypeContent;
        const countryCondition =
          selectedCountry === "All" || (Array.isArray(item.countries) ? item.countries.includes(selectedCountry) : item.country === selectedCountry);
  
        return categoryCondition && typeContentCondition && countryCondition;
      });
    }
  
    setFilteredData(filteredData);
  
    if (filteredData.length === 0) {
      setErrorMessage(
        `No items found for ${selectedTypeContent} ${selectedCategory} ${selectedCountry}`
      );
    } else {
      setErrorMessage("");
    }
  };

  const resetFilter = () => {
    setSelectedCategory("All");
    setSelectedTypeContent("All");
    setSelectedCountry("All");
    setFilteredData(data);
    setErrorMessage("");
  };

  const uniqueCategories = [
    "All",
    ...new Set(data.map((item) => item.category)),
  ];
  const uniqueTypeContent = [
    "All",
    ...new Set(data.map((item) => item.typecontent)),
  ];

  const location = useLocation();
  const prefix = useLocalePrefix();
  const { t } = useTranslation();
  return (
    <>
      {isLoading && (
        <div class="fixed inset-0 flex items-center justify-center"> 
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      <section class="px-4 py-24 mx-auto max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div class="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center">
          <h2 className="mb-3 text-xs font-semibold tracking-widest text-black uppercase title-font text-pirGray-100">
            {t("ourbloguppercase")}
          </h2>
          <h1 class="mb-6 text-4xl font-extrabold leading-none tracking-normal text-gray-900 md:text-5xl md:tracking-tight">
            {t("ourblogtitle1")}{" "}
            <span class="block w-full text-transparent bg-clip-text bg-gradient-to-r from-[#000C8A] to-[#DB2415] lg:inline">
              {t("ourblogtitlespan")}
            </span>{" "}
            {t("ourblogtitle2")}
          </h1>
        </div>

        <div
          class="
                  p-2
                  mt-16
                  transition
                  duration-500
                  ease-in-out
                  transform
                  border2
                  bg-gray-50
                  md:mx-auto
                  rounded-xl
                  sm:max-w-5xl
                  lg:flex
                  mb-8
                "
        >
          <div class="lg:flex space-x-12">
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300
              "
              >
                {/* {uniqueCategories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))} */}
                <option value="All">{t("categoryblog1")}</option>
                {/* <option value="Finances">{t("categoryblog2")}</option> */}
                {/* <option value="Payments">{t("categoryblog3")}</option> */}
                {/* <option value="Customers">{t("categoryblog4")}</option> */}
                <option value="Management">{t("categoryblog5")}</option>
                {/* <option value="Marketing">{t("categoryblog6")}</option> */}
                <option value="Press release">{t("categoryblog7")}</option>
                {/* <option value="Informative">{t("categoryblog8")}</option> */}
                {/* <option value="System POS">Sistema POS</option> */}
                {/* <option value="Delivery">Delivery</option> */}
                
                {/* <option value="Educational">{t("categoryblog9")}</option> */}
              </select>
            </div>
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedTypeContent}
                onChange={(e) => setSelectedTypeContent(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300
              "
              >
                {/* {uniqueTypeContent.map((typecontent) => (
                  <option key={typecontent} value={typecontent}>
                    {typecontent}
                  </option>
                ))} */}
                <option value="All">{t("typecontentblog1")}</option>
                {/* <option value="Articles">{t("typecontentblog2")}</option> */}
                {/* <option value="Guides">{t("typecontentblog3")}</option> */}
                {/* <option value="Finances">{t("categoryblog2")}</option> */}
                {/* <option value="Tools">{t("typecontentblog4")}</option> */}
              </select>
            </div>
            <div class="flex-1 min-w-0 revue-form-group">
              <select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                class="
                block
                w-full
                px-5
                py-3
                text-base text-neutral-600
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                bg-transparent
                border border-transparent
                rounded-md
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300"
              >
                <option value="All">Todos los países</option>
                {/* <option value="Panama">Panamá</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Mexico">México</option> */}
                <option value="Republica Dominicana">República Dominicana</option>
              </select>
            </div>

          </div>
          <div class="mt-4 sm:mt-0 lg:ml-3 revue-form-actions">
            <button
              onClick={() => {
                filterItems();
                handleFilterButtonClick();
              }}
              class="
               block
               w-full
               px-5
               py-3
               text-base
               text-white
               bg-indigo-600
               border border-transparent
               rounded-lg
               shadow
               font-semibold
               hover:bg-indigo-700
               focus:outline-none
               focus:ring-2
               focus:ring-white
               focus:ring-offset-2
               focus:ring-offset-gray-300
               sm:px-10
             "
            >
              {t("filtersearchblogbutton")}
            </button>
          </div>
        </div>

        {/* <div class="grid grid-cols-1 mt-24 gap-12 md:grid-cols-2 lg:grid-cols-2 ">
          <div>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              class="block"
              to={`${prefix}` + "/blog/programas-de-contabilidad-en-la-nube"}
            >
              <img
                class="object-cover w-full h-82 shadow-xl rounded-xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/Blog%2021/Cover%20blog%2021%20.jpeg"
                alt=""
              />

              <div class="mt-10">
                <div class="h-full flex items-start">
                  <div class="w-12 flex-shrink-0 flex flex-col text-center leading-none">
                    <span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">
                      Jul
                    </span>
                    <span class="font-medium text-lg text-gray-800 title-font leading-none">
                      07
                    </span>
                  </div>
                  <div class="flex-grow pl-6">
                    <h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1 uppercase">
                      Destacado
                    </h2>
                    <h1 class="title-font max-w-md text-xl font-semibold text-gray-900 mb-3">
                      Software de contabilidad y facturación en la nube
                    </h1>
                    <p class="mt-2 max-w-lg text-gray-600 ">
                      A día de hoy, y gracias al avance de la tecnología, los
                      softwares de contabilidad en la nube se han convertido en
                      muy valiosas herramientas de trabajo para los
                      departamentos de contabilidad de las empresas.
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div>
            <Link
              class="block"
              onClick={() => window.scrollTo(0, 0)}
              to={`${prefix}` + "/blog/facturacion-electronica-dgi-2022"}
            >
              <img
                class="object-cover w-full h-82 shadow-xl rounded-xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/Blog%2022/Cover%20blog%2022%20.jpeg"
                alt=""
              />

              <div class="mt-10">
                <div class="h-full flex items-start">
                  <div class="w-12 flex-shrink-0 flex flex-col text-center leading-none">
                    <span class="text-gray-500 pb-2 mb-2 border-b-2 border-gray-200">
                      Jul
                    </span>
                    <span class="font-medium text-lg text-gray-800 title-font leading-none">
                      08
                    </span>
                  </div>
                  <div class="flex-grow pl-6">
                    <h2 class="tracking-widest text-xs title-font font-medium text-indigo-500 mb-1">
                      DESTACADO
                    </h2>
                    <h1 class="title-font max-w-md text-xl font-semibold text-gray-900 mb-3">
                      Facturación electrónica en Panamá: requisitos y novedades
                    </h1>
                    <p class="mt-2 max-w-lg text-gray-600 ">
                      En Panamá, la factura electrónica es un modelo de
                      facturación que, además de reemplazar el uso de impresoras
                      fiscales, acelera la transformación digital de las
                      empresas e impulsa el ingreso de los emprendedores en la
                      economía formal.
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div> */}
      </section>
      {showButton && (
        <>
          <button
            onClick={handleScrollToTop}
            class="fixed bottom-0 right-0 m-4 p-2 group flex items-center justify-between gap-4 rounded-lg border border-indigo-600 bg-indigo-600 px-5 py-3 transition-colors hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            <span class="font-medium text-white transition-colors group-hover:text-white group-active:text-indigo-500">
              {t("fixedbuttonscroll")}
            </span>

            <span class="flex-shrink-0 rounded-full border border-current bg-white p-2 text-indigo-600 group-active:text-indigo-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </button>
        </>
      )}
      <section id="results-section" className="bg-gray-100">
        <div className="px-4 py-24 mx-auto max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
          <h1 className="-mt-8 text-4xl font-bold xl:block hidden leading-tight text-gray-800">
            {t("titlelistblog")}
          </h1>
          <span class="block w-24 h-2 mt-1 xl:block hidden  bg-gradient-to-r from-pirLightBlue to-pirPurple hover:from-pirPink hover:to-pirOrange "></span>

          <h1 className="-mt-8 text-3xl mb-4 font-bold xl:hidden block leading-tight lg:leading-10 text-gray-800">
            {t("titlelistblog")}
          </h1>
          <span class="block w-24 h-2 mt-1 lg:invisible  bg-gradient-to-r from-pirLightBlue to-pirPurple hover:from-pirPink hover:to-pirOrange "></span>
          <div>
            {" "}
            {errorMessage && (
              <>
                <div class="rounded-3xl mt-8 shadow-2xl">
                  <div class="p-8 text-center sm:p-12">
                    <p class="text-sm font-semibold uppercase tracking-widest text-indigo-500">
                      {t("errormessageblogs")}
                    </p>

                    <h2 class="mt-6 text-3xl font-bold">{errorMessage}</h2>

                    <button
                      class="mt-8 inline-block lg:w-96 md:w-96 w-52 rounded-full bg-indigo-600 py-4 text-lg font-bold text-white transition hover:scale-110 hover:shadow-xl focus:outline-none focus:ring active:bg-indigo-500"
                      onClick={resetFilter}
                    >
                      {t("buttonrefreshblogs")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="grid gap-6  grid-cols-1 mt-8 grid grid-cols-1 gap-12 md:grid-cols-2  lg:grid-cols-2 xl:grid-cols-3">
            {!filteredData
              ? sortedData.map((item, index) => (
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    to={`${prefix}` + item.href}
                    key={index}
                  >
                    <div className="overflow-hidden transition-shadow duration-300 bg-white rounded">
                      <a aria-label="Article">
                        <img
                          src={item.imageSrc}
                          className="object-cover w-full h-64 rounded-t-lg"
                          alt=""
                        />
                      </a>
                      <div className="py-5 p-6">
                        <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-sm text-purple-700">
                          {item.typecontent}
                        </span>
                        <div className="flex justify-between items-end mt-3">
                          {item.countries && Array.isArray(item.countries) ? (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.countries.join(', ')}
                            </p>
                          ) : (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.country}
                            </p>
                          )}
                        </div>
                        <a
                          aria-label="Article"
                          className="inline-block mt-2.5 mb-3 text-black transition-colors duration-200 hover:text-deep-purple-accent-700"
                        >
                          <p className="text-2xl font-bold leading-7">
                            {item.name.length > 72
                              ? `${item.name.substring(0, 72)}...`
                              : item.name}
                          </p>
                        </a>
                        <p className="mb-4 text-gray-700">
                          {item.description.length > 240
                            ? `${item.description.substring(0, 238)}...`
                            : item.description}
                        </p>
                        <div class="mt-1.5 sm:mt-0">
                          <p class="text-gray-500 italic text-sm">{item.category}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
                : sortedFilteredData.map((item, index) => (
                  <Link
                    onClick={() => window.scrollTo(0, 0)}
                    to={`${prefix}` + item.href}
                    key={index}
                  >
                    <div className="overflow-hidden transition-shadow duration-300 bg-white rounded">
                      <a aria-label="Article">
                        <img
                          src={item.imageSrc}
                          className="object-cover w-full h-64 rounded-t-lg"
                          alt=""
                        />
                      </a>
                      <div className="py-5 p-6">
                      <span class="whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-0.5 text-sm text-purple-700">
                          {item.typecontent}
                        </span>
                        <div className="flex justify-between items-end mt-3">
                          {item.countries && Array.isArray(item.countries) ? (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.countries.join(', ')}
                            </p>
                          ) : (
                            <p className="mb-2 text-xs font-semibold text-gray-600 uppercase">
                              {item.date} | {item.country}
                            </p>
                          )}
                        </div>
                        <a
                          aria-label="Article"
                          className="inline-block mt-2.5 mb-3 text-black transition-colors duration-200 hover:text-deep-purple-accent-700"
                        >
                          <p className="text-2xl font-bold leading-7">
                            {item.name.length > 72
                              ? `${item.name.substring(0, 72)}...`
                              : item.name}
                          </p>
                        </a>
                        <p className="mb-4 text-gray-700">
                          {item.description.length > 240
                            ? `${item.description.substring(0, 238)}...`
                            : item.description}
                        </p>
                        <div class="mt-1.5 sm:mt-0">
                          <p class="text-gray-500 italic text-sm">{item.category}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogRD;
